import { Button, Heading } from 'yoso';
import { T } from '~/components/I18n';
import './HelpContact.scss';

export const HelpContact = () => (
  <div className="help-contact">
    <Heading level={4}>
      <T name="citizen_help_to_contact" />
    </Heading>
    <Button
      as="a"
      href={import.meta.env.VITE_INQUIRY_FORM_URL}
      color="primary"
      size="large"
      className="help-contact-button"
      target="_blank">
      <T name="citizen_contact" />
    </Button>
  </div>
);
